import EditDimensionList from './EditDimensionList';

export default EditDimensionList;
